import type { PlatformDownloadId } from '@/config/downloads';

export type Locale = 'zh-CN' | 'en';

export const LOCALES: Locale[] = ['zh-CN', 'en'];

export const LOCALE_STORAGE_KEY = 'fustar-home-locale';

export interface FeatureMessages {
  id: string;
  title: string;
  paragraphs: string[];
}

export interface CapabilityMessages {
  eyebrow: string;
  title: string;
  description: string;
}

export interface Messages {
  meta: {
    title: string;
    description: string;
  };
  header: {
    tagline: string;
  };
  language: {
    switchLabel: string;
    zh: string;
    en: string;
  };
  theme: {
    switchToLight: string;
    switchToDark: string;
  };
  hero: {
    brandTitle: string;
    subtitle: string;
    featureTags: readonly string[];
    downloadCta: string;
    exploreCta: string;
    previewLabel: string;
  };
  navigation: {
    workspace: string;
    capabilities: string;
    demos: string;
    stats: string;
    faq: string;
    download: string;
  };
  useCaseDemos: {
    eyebrow: string;
    title: string;
    description: string;
    sortLabel: string;
    videoPlaceholder: string;
    sortOptions: Record<'featured' | 'plugin' | 'recent', string>;
    items: Record<
      string,
      {
        category: string;
        title: string;
        description: string;
        author: string;
      }
    >;
  };
  workspace: {
    eyebrow: string;
    title: string;
    description: string;
    previewLabel: string;
    runCta: string;
    resetCta: string;
    readyStatus: string;
    computingStatus: string;
    storedStatus: string;
    visualLabel: string;
    computeLabel: string;
    storageLabel: string;
    queryLabel: string;
    query: string;
    tableLabel: string;
    noteLabel: string;
    noteTitle: string;
    noteBody: string;
    agentLabel: string;
    agentTitle: string;
    agentBody: string;
    insightLabel: string;
    insightTitle: string;
    insightMetric: string;
    insightDetail: string;
    dataSource: string;
    computeLogs: readonly string[];
    sidebarNotes: string;
    sidebarSources: string;
    sidebarProjects: string;
  };
  capabilities: {
    eyebrow: string;
    title: string;
    description: string;
    items: readonly CapabilityMessages[];
  };
  stats: {
    eyebrow: string;
    title: string;
    description: string;
    items: readonly {
      value: string;
      label: string;
      description: string;
    }[];
  };
  download: {
    eyebrow: string;
    title: string;
    description: string;
  };
  openSource: {
    eyebrow: string;
    title: string;
    description: string;
    badge: string;
    cta: string;
  };
  platforms: Record<
    PlatformDownloadId,
    {
      label: string;
      hint: string;
    }
  >;
  platformsHover: {
    download: string;
    open: string;
  };
  features: FeatureMessages[];
  illustrations: {
    local: string;
    agent: string;
    vision: string;
  };
  faq: {
    eyebrow: string;
    title: string;
    items: readonly {
      question: string;
      answer: string;
    }[];
  };
  waitlist: {
    eyebrow: string;
    title: string;
    description: string;
    placeholder: string;
    codePlaceholder: string;
    sendCodeButton: string;
    verifyButton: string;
    resendCode: string;
    sending: string;
    verifying: string;
    error: string;
    success: string;
  };
  footer: {
    privacy: string;
  };
}
